<template>
    <master-page>
        <br/>
        <v-card>
            <v-card-title style="background: var(--v-primary-base); position: sticky; top: 75px; z-index: 1; color: white !important">
                <v-icon large left style="color: white">mdi-account-cash</v-icon>
                <span class="title font-weight-light">Configuração do Recibo para Doadores</span>
                <v-spacer/>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="GerarRelatorio()" v-on="on"><v-icon>mdi-text-box-check</v-icon></v-btn>
                    </template>
                    <span>Gerar Relatório</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="LimparFiltros()" v-on="on"><v-icon>mdi-eraser</v-icon></v-btn>
                    </template>
                    <span>Limpar</span>
                </v-tooltip>
            </v-card-title>
            <v-card-text class="mt-3">
                <v-row>
                    <v-col cols="12" sm="8" md="10">
                        <v-autocomplete v-model="filtro.doadorId" :items="doadores" :loading="isDoadorLoading" :search-input.sync="onSearchDoador" clearable
                          item-text="nome" item-value="id" label="Doador" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="4" md="2">
                        <v-text-field v-model="filtro.documentoId" label="Documento" dense outlined>
                            <template v-slot:append-outer>
                                <v-icon color="primary" @click="dialogFiltroRecebivel = true">mdi-file-search</v-icon>
                            </template>
                        </v-text-field>
                    </v-col>                    
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6" md="6">
                        <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                            <template v-slot:activator="{on}">
                                <v-text-field type="date" v-model="filtro.dataInicio" label="Data Pagamento (Inicio)" :rules="fieldRules" dense outlined>
                                    <template v-slot:prepend>
                                        <v-icon v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker locale="pt-br" v-model="filtro.dataInicio" no-title/>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                            <template v-slot:activator="{on}">
                                <v-text-field type="date" v-model="filtro.dataTermino" label="Data Pagamento (Término)" :rules="fieldRules" dense outlined>
                                    <template v-slot:prepend>
                                        <v-icon v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker locale="pt-br" v-model="filtro.dataTermino" no-title/>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12" md="5">
                        <v-select v-model="filtro.regiaoId" label="Região/Grupo" :items="regioes" item-value="id" item-text="nome" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="5">
                        <v-select v-model="filtro.layoutId" label="Layout" :items="layouts" item-value="id" item-text="nome" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-switch v-model="filtro.exibirNomeProjeto" :disabled="filtro.layoutId == 1" label="Exibir Nome Projeto" style="margin-top: 5px"/>
                    </v-col>
                </v-row>
                
            </v-card-text>
        </v-card>

        <filtro-recebivel v-model="dialogFiltroRecebivel" :selectedDocumento="documentoSelecionado" @fechou="dialogFiltroRecebivel = false"/>

    </master-page>
</template>

<script>
import { DoadorService, RegiaoService } from '@/core/services/doacao';
import RecebivelService from '../../../core/services/financeiro/RecebivelService';

export default {
    data: () => ({
        filtro: {
            doadorId: 0,
            documentoId: 0,
            dataInicio: null,
            dataTermino: null,
            regiaoId: null,
            layoutId: 0,
            exibirNomeProjeto: false
        },
        regiaoService: new RegiaoService(),
        regioes:[],
        layouts:[
            {
                id: 0,
                nome: "1 por página"
            },
            {
                id: 1,
                nome: "3 por página"
            }
        ],
        doadorService: new DoadorService(),
        doadores: [],
        isDoadorLoading: false,
        onSearchDoador: null,
        documentos: [],
        isDocumentoLoading: false,
        recebivelService: new RecebivelService(),
        onSearchDocumento: null,
        dialogFiltroRecebivel: false,
        documentoSelecionado: [],
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ]
    }),
    watch:{
        onSearchDoador(val){
            if(this.isDoadorLoading) return;
            if(!val) return;

            this.isDoadorLoading = true;
            this.doadorService.AutoComplete(val)
            .then(
                res=>{
                    this.doadores = res.data
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            )
            .finally(() => (this.isDoadorLoading = false))
        },
        onSearchDocumento(val){
            if(this.isDocumentoLoading) return;
            if(!val) return;

            this.isDocumentoLoading = true;
            this.recebivelService.AutoComplete(val)
            .then(
                res=>{
                    this.documentos = res.data
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            )
            .finally(() => (this.isDocumentoLoading = false))
        },
        documentoSelecionado(){
            this.filtro.documentoId = 0;
            this.filtro.documentoId = this.documentoSelecionado[0].id;            
        }
    },
    methods: {
        GerarRelatorio(){
            this.AbrirJanela('relatorioReciboDoador');
        },
        LimparFiltros(){
            this.filtro = {
                doadorId: 0,
                documentoId: 0,
                dataInicio: null,
                dataTermino: null,
                regiaoId: null,
                layoutId: 0,
                exibirNomeProjeto: false
            }
            this.doadores = [],
            this.documentos = []
        },
        AbrirJanela(rota) {
            let routeLink = this.$router.resolve({ name: rota,
                query:{
                    doadorId: this.filtro.doadorId,
                    documentoId: this.filtro.documentoId,
                    pagamentoInicial: this.filtro.dataInicio,
                    pagamentoFinal: this.filtro.dataTermino,
                    regiaoId: this.filtro.regiaoId,
                    layoutId: this.filtro.layoutId,
                    exibirNomeProjeto: this.filtro.exibirNomeProjeto
                }
            });
            window.open(routeLink.href,'_blank');
        }
    },
    mounted(){
        this.regiaoService.ListarTudo()
            .then(
                res => {
                    this.regioes = res.data.items;
                    this.regioes.unshift({
                        id: null,
                        nome: '---TODOS---'
                    })
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );
    }
}

</script>